import { Box, Table, Text } from '@factorialco/deprecated-design-system'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'

interface SummaryDateCellProps {
  date: string
}

export const SummaryDateCell = ({ date }: SummaryDateCellProps) => (
  <Table.Cell noBorder width={108} paddingX="s4" paddingY="s2">
    <Box style={{ paddingLeft: '20px' }}>
      <Text.Normal size="200">{dateBackendDateTimeToUI(date)}</Text.Normal>
    </Box>
  </Table.Cell>
)
